import React from "react";

const Highlights = () => {
  const isMobile = window.innerWidth < 768;

  return (
    <section
      style={{
        padding: isMobile ? "20px" : "50px",
        margin: "30px 0",
        borderRadius: "20px",
        background: "linear-gradient(135deg, #f3fff7, #ffffff)",
        border: "1px solid #c3ecd3",
        boxShadow: "0 10px 40px rgba(0,0,0,0.12)",
      }}
    >
      {/* MAIN TITLE */}
      <h2
        style={{
          textAlign: "center",
          fontSize: isMobile ? "20px" : "36px",
          fontWeight: "900",
          color: "#0f5132",
          marginBottom: isMobile ? "12px" : "25px",
          lineHeight: isMobile ? "26px" : "normal",
        }}
      >
        ⚙️ Our Services – Premium EV Bike Collection
      </h2>

      <p
        style={{
          textAlign: "center",
          fontSize: isMobile ? "13px" : "18px",
          maxWidth: "900px",
          margin: "0 auto 30px auto",
          color: "#1b4332",
          lineHeight: isMobile ? "1.4" : "1.6",
          padding: isMobile ? "0 6px" : "0",
        }}
      >
        SSP NextGen E-Bikes offers the most advanced and reliable electric bikes
        in Hyderabad. We provide powerful, long-range EV scooters with superior
        features, best mileage, modern technology and smooth riding experience.
      </p>

      {/* RESPONSIVE CARDS */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: isMobile ? "15px" : "25px",
          justifyContent: "center",
        }}
      >
        {[
          {
            name: "SSP EV Models",
            icon: "🛵",
            desc: "Premium flagship EV bikes known for durability, comfort and powerful range.",
          },
          {
            name: "Zelio EV Bikes",
            icon: "⚡",
            desc: "Top-selling models with 60–90 km mileage and stylish modern design.",
          },
          {
            name: "JV Models",
            icon: "🔋",
            desc: "Efficient battery systems, smooth ride quality and long-range performance.",
          },
          {
            name: "Marrium EV Series",
            icon: "🛞",
            desc: "Comfort-based EV bikes with excellent braking systems and smooth handling.",
          },
          {
            name: "Rabbitor EV Bikes",
            icon: "🏆",
            desc: "Premium look, superior comfort and powerful riding experience.",
          },
        ].map((bike, index) => (
          <div
            key={index}
            style={{
              width: isMobile ? "100%" : "260px",
              padding: isMobile ? "18px" : "25px",
              borderRadius: "16px",
              background: "white",
              border: "1px solid #e8e8e8",
              boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
              transition: "0.3s",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 30px rgba(0,0,0,0.18)";
                e.currentTarget.style.border = "1px solid #68d391";
              }
            }}
            onMouseLeave={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(0,0,0,0.08)";
                e.currentTarget.style.border = "1px solid #e8e8e8";
              }
            }}
          >
            {/* ICON */}
            <div
              style={{
                fontSize: isMobile ? "26px" : "40px",
                marginBottom: "10px",
              }}
            >
              {bike.icon}
            </div>

            {/* NAME */}
            <h3
              style={{
                fontSize: isMobile ? "15px" : "20px",
                fontWeight: "800",
                color: "#087f5b",
                marginBottom: "8px",
              }}
            >
              {bike.name}
            </h3>

            {/* DESCRIPTION */}
            <p
              style={{
                lineHeight: "1.5",
                color: "#1b4332",
                fontSize: isMobile ? "12px" : "16px",
              }}
            >
              {bike.desc}
            </p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <p
        style={{
          marginTop: "35px",
          textAlign: "center",
          fontSize: isMobile ? "13px" : "20px",
          fontWeight: "700",
          color: "#087f5b",
        }}
      >
        ✔ SSP NextGen – Best E-Bikes in Hyderabad for Mileage, Features &
        Performance
      </p>
    </section>
  );
};

export default Highlights;